import { render } from "./articles.vue?vue&type=template&id=40fcf1ae&lang=pug"
import script from "./articles.vue?vue&type=script&setup=true&lang=js"
export * from "./articles.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__